import { connect } from 'react-redux'
import Create from './Create'
import { createPoll } from '../../redux/actions/poll'

const mapStateToProps = ({ polls }) => ({
	polls: Object.values(polls),
})

const mapDispatchToProps = (dispatch) => ({
	submit(data) {
		dispatch(createPoll(data))
	},
})

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Create)

export default Container



// WEBPACK FOOTER //
// ./src/components/create/Container.jsx